export class ReceiverDto{
  public receiverAddress!:string
  public receiverName!:string
}
